<template>
  <div class="reset">
    <alert :shown="showAlert" :title="alertTitle" :type="alertType" :content="alertContent" />
    <h1>Request password reset</h1>
    <!-- <p>This feature is coming soon. In the meantime, please <a href="mailto:fencingtrainer@gmail.com">contact us</a> and we will help to reset your password!</p> -->
    <form>
      <div class="form-group">
        <label class="form-label" for="email">Email</label>
        <input class="form-input" type="email" id="email" v-model="email" autocorrect="off" autocapitalize="none" />
      </div>
      <vue-hcaptcha sitekey="fe762571-9004-4aaa-9bb1-f40716c2e4c1" @verify="onCaptchad"></vue-hcaptcha>
      <button class="btn btn-primary" id="retrieveBtn" v-on:click.prevent="reset" :disabled="!captchad">Submit</button>&nbsp;
    </form>
    <a href="/">Return to login</a>
  </div>
</template>

<script>
import config from "@/config"
import alert from "../components/Alert"
import { EventBus } from '../main'
import VueHcaptcha from '@hcaptcha/vue-hcaptcha'

export default {
  name: 'passwordreset',
  components : {
    alert,
    VueHcaptcha
  },
  data (){
    return {
      email : "",
      showAlert : "",
      alertTitle : "",
      alertType : "",
      alertContent : "",
      captchad : false,
      captchaResponse : ""
    }
  },
  methods : {
    reset () {
      // reset the password
      fetch(config.baseUrl+"user/password/reset/", {
        method : "POST",
        body : JSON.stringify({
          email : this.email,
          captchaResponse : this.captchaResponse
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        credentials : "include"
      }).then(e => {
        return e.json()
      }).then(j => {
        this.alertType = "success"
        this.alertTitle = "Password request sent"
        this.alertContent = j.msg
        this.showAlert = "shown"

      })
    },
    onCaptchad (e) {
      this.captchad = true
      this.captchaResponse = e
    }
  },
  created(){
    EventBus.$on("hideAlert", () => {
      this.showAlert = ""
    })
  }
}
</script>

<style lang="scss">
  .reset {
    padding-right: 20px;
    max-width: 400px;
  }
</style>
